"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.track = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var constants_1 = require("./constants");
exports.track = (0, typesafe_actions_1.createStandardAction)(constants_1.TRACK_EVENT)();